import api from "@/Library/api.js";

export default {

    GET_SYSTEM_IMAGE_LIST(data) {
        return api({ url: "/Systemimage/GetSystemImageList", method: "post", data: data });
    },

    ADD_SYSTEM_IMAGE(data) {
        return api({ url: "/Systemimage/AddSystemImage", method: "post", data: data });
    },

    EDIT_SYSTEM_IMAGE(data) {
        return api({ url: "/Systemimage/EditSystemImage", method: "post", data: data });
    },

    DEL_SYSTEM_IMAGE(data) {
        return api({ url: "/Systemimage/DelSystemImage", method: "post", data: data });
    },

}
